import { render, staticRenderFns } from "./ieltsmentor_collapse_chinh_sach_bao_mat.vue?vue&type=template&id=8faf34da&scoped=true"
import script from "./ieltsmentor_collapse_chinh_sach_bao_mat.vue?vue&type=script&lang=js"
export * from "./ieltsmentor_collapse_chinh_sach_bao_mat.vue?vue&type=script&lang=js"
import style0 from "./ieltsmentor_collapse_chinh_sach_bao_mat.vue?vue&type=style&index=0&id=8faf34da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8faf34da",
  null
  
)

export default component.exports